import { render, staticRenderFns } from "./StudioShots.vue?vue&type=template&id=c42e72fc&lang=html"
import script from "./StudioShots.vue?vue&type=script&lang=js"
export * from "./StudioShots.vue?vue&type=script&lang=js"
import style0 from "./StudioShots.vue?vue&type=style&index=0&id=c42e72fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports